export default "__VITE_ASSET__LdkSl8Al__"